// Copyright (c) StrangeBee 2023

import { Button, Space } from 'antd';
import React, { ReactElement } from 'react';
import { PageDirection } from '@Constants/pagination';
import { useLocalMessage } from '@Helpers/';

import './THTableFooter.scss';

interface THTableFooterProps {
    page: number;
    itemsPerPage: number;
    total: number;
    onPageChange: (page: number) => void;
}

const THTableFooter = ({ page, itemsPerPage, total, onPageChange }: THTableFooterProps): ReactElement | null => {
    const i = useLocalMessage();

    const handleChange = (direction: PageDirection): void => {
        const countPage = Math.ceil(total / itemsPerPage) - 1;
        const newPage = Math.max(0, Math.min(page + direction, countPage));

        if (page !== newPage) {
            onPageChange(newPage);
        }
    };

    const from = page * itemsPerPage;

    const to = (page + 1) * itemsPerPage;

    return (
        <div className="th-table-footer">
            {itemsPerPage < total && (
                <Space>
                    <Button
                        size="small"
                        onClick={(): void => handleChange(PageDirection.PREVIOUS)}
                        disabled={from === 0}
                    >
                        <Space>
                            {'< '}
                            {i('list.pagination.previous')}
                        </Space>
                    </Button>
                    <span>
                        {from} - {to > total ? total : to} {i('list.pagination.of')} {total}
                    </span>
                    <Button size="small" onClick={(): void => handleChange(PageDirection.NEXT)} disabled={to >= total}>
                        <Space>
                            {i('list.pagination.next')} {' >'}
                        </Space>
                    </Button>
                </Space>
            )}
        </div>
    );
};

export default THTableFooter;
